var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import { ApolloConsumer } from 'react-apollo';
import { Formik, Form } from 'formik';
import gql from 'graphql-tag';
import Product from './Product';
import { GET_HOME } from '.';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  overflow: hidden;\n\n  > form {\n    > .product {\n      width: 100%;\n      margin-bottom: 20px;\n  \n      > .box {\n        float: left;\n        width: 25%;\n        height: 400px;\n        padding: 10px;\n    \n        > .box-bg {\n          width: 100%;\n          height: 100%;\n          background-size: cover;\n          position: relative;\n\n          > .controller {\n            position: absolute;\n            width: 100%;\n            height: 50px;\n            padding: 10px;\n            bottom: 0;\n            left: 0;\n            background: rgba(255, 255, 255, 0.2);\n\n            > ul {\n              width: 100%;\n              height: 100%;\n\n              > li {\n                width: calc(100% / 3);\n                height: 100%;\n                float: left;\n                line-height: 30px;\n                text-align: center;\n                color: #fff;\n                \n                > span {\n                  cursor: pointer;\n                  font-size: 14px;\n                }\n              }\n            }\n          }\n        }\n      }\n  \n      > .add {\n        height: 100%;\n  \n        > .add-btn {\n          cursor: pointer;\n          background-color: #4BC6B9;\n          line-height: 380px;\n          font-size: 18px;\n          text-align: center;\n          color: #fff;\n        }\n      }\n    }\n  \n    > .update-btn {\n      width: 100%;\n      padding: 10px;\n      clear: both;\n  \n      > button {\n        all: unset;\n        box-sizing: border-box;\n        cursor: pointer;\n        background: #36c;\n        color: #fff;\n        width: 100%;\n        height: 50px;\n        padding: 10px;\n        font-size: 18px;\n        line-height: 30px;\n        text-align: center;\n        margin-bottom: 100px;\n      }\n    }\n  }\n"], ["\n  width: 100%;\n  overflow: hidden;\n\n  > form {\n    > .product {\n      width: 100%;\n      margin-bottom: 20px;\n  \n      > .box {\n        float: left;\n        width: 25%;\n        height: 400px;\n        padding: 10px;\n    \n        > .box-bg {\n          width: 100%;\n          height: 100%;\n          background-size: cover;\n          position: relative;\n\n          > .controller {\n            position: absolute;\n            width: 100%;\n            height: 50px;\n            padding: 10px;\n            bottom: 0;\n            left: 0;\n            background: rgba(255, 255, 255, 0.2);\n\n            > ul {\n              width: 100%;\n              height: 100%;\n\n              > li {\n                width: calc(100% / 3);\n                height: 100%;\n                float: left;\n                line-height: 30px;\n                text-align: center;\n                color: #fff;\n                \n                > span {\n                  cursor: pointer;\n                  font-size: 14px;\n                }\n              }\n            }\n          }\n        }\n      }\n  \n      > .add {\n        height: 100%;\n  \n        > .add-btn {\n          cursor: pointer;\n          background-color: #4BC6B9;\n          line-height: 380px;\n          font-size: 18px;\n          text-align: center;\n          color: #fff;\n        }\n      }\n    }\n  \n    > .update-btn {\n      width: 100%;\n      padding: 10px;\n      clear: both;\n  \n      > button {\n        all: unset;\n        box-sizing: border-box;\n        cursor: pointer;\n        background: #36c;\n        color: #fff;\n        width: 100%;\n        height: 50px;\n        padding: 10px;\n        font-size: 18px;\n        line-height: 30px;\n        text-align: center;\n        margin-bottom: 100px;\n      }\n    }\n  }\n"])));
var UPLOAD_FILE = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation UploadFile($file: Upload!) {\n    uploadFile(file: $file) {\n      path\n    }\n  }\n"], ["\n  mutation UploadFile($file: Upload!) {\n    uploadFile(file: $file) {\n      path\n    }\n  }\n"])));
var UPDATE_HOME_PRODUCTS = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation UpdateHomeProducts($homeProducts: UpdatingHomeProductsInput!) {\n    updateHomeProducts(homeProducts: $homeProducts)\n  }\n"], ["\n  mutation UpdateHomeProducts($homeProducts: UpdatingHomeProductsInput!) {\n    updateHomeProducts(homeProducts: $homeProducts)\n  }\n"])));
export default (function (_a) {
    var products = _a.products, project = _a.project;
    var _b = React.useState({}), imageMap = _b[0], setImageMap = _b[1];
    var _c = React.useState(0), counter = _c[0], setUpdateCounter = _c[1];
    function forceUpdate() {
        setUpdateCounter(function (prev) { return prev + 1; });
    }
    function registerImage(idx, file) {
        setImageMap(function (prevImageMap) {
            var _a;
            return (__assign({}, prevImageMap, (_a = {}, _a[idx] = file, _a)));
        });
    }
    function submit(value, client) {
        return __awaiter(this, void 0, void 0, function () {
            var uploadImagesMap, entries;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, uploadImages(client)];
                    case 1:
                        uploadImagesMap = _a.sent();
                        entries = Object.entries(uploadImagesMap);
                        if (entries.length) {
                            entries.forEach(function (_a) {
                                var idx = _a[0], path = _a[1];
                                value.products[idx].bgUrl = path;
                            });
                        }
                        value.products.forEach(function (product) {
                            delete product.__typename;
                        });
                        return [4 /*yield*/, client.mutate({
                                mutation: UPDATE_HOME_PRODUCTS,
                                variables: {
                                    homeProducts: {
                                        projectName: project,
                                        products: value.products,
                                    }
                                },
                                refetchQueries: [{
                                        query: GET_HOME,
                                        variables: {
                                            projectName: project,
                                        }
                                    }]
                            })];
                    case 2:
                        _a.sent();
                        window.alert('변경이 반영되었습니다.');
                        setImageMap({});
                        return [2 /*return*/];
                }
            });
        });
    }
    function uploadImages(client) {
        return __awaiter(this, void 0, void 0, function () {
            var entries, uploadedImageMap;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entries = Object.entries(imageMap);
                        uploadedImageMap = {};
                        if (!entries.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(entries.map(function (_a) {
                                var idx = _a[0], file = _a[1];
                                return __awaiter(_this, void 0, void 0, function () {
                                    var path;
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0:
                                                if (!file) {
                                                    return [2 /*return*/];
                                                }
                                                return [4 /*yield*/, client.mutate({
                                                        mutation: UPLOAD_FILE,
                                                        variables: { file: file }
                                                    })];
                                            case 1:
                                                path = (_b.sent()).data.uploadFile.path;
                                                uploadedImageMap[idx] = path;
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            }))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, uploadedImageMap];
                }
            });
        });
    }
    function moveToLeft(products, idx) {
        var temp = products[idx];
        products[idx] = products[idx - 1];
        products[idx - 1] = temp;
        setImageMap(function (prev) {
            var _a;
            return (__assign({}, prev, (_a = {}, _a[idx - 1] = prev[idx], _a[idx] = prev[idx - 1], _a)));
        });
    }
    function moveToRight(products, idx) {
        var temp = products[idx];
        products[idx] = products[idx + 1];
        products[idx + 1] = temp;
        setImageMap(function (prev) {
            var _a;
            return (__assign({}, prev, (_a = {}, _a[idx + 1] = prev[idx], _a[idx] = prev[idx + 1], _a)));
        });
    }
    function remove(products, idx) {
        products.splice(idx, 1);
        var newImageMap = {};
        Object.entries(imageMap).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (key > idx) {
                newImageMap[Number(key) - 1] = value;
            }
            else if (key < idx) {
                newImageMap[key] = value;
            }
        });
        setImageMap(newImageMap);
    }
    function addNewProduct(products) {
        products.push({
            bgUrl: counter,
            name: '',
            link: '',
        });
        forceUpdate();
    }
    return (React.createElement(ApolloConsumer, null, function (client) { return (React.createElement(Formik, { initialValues: { products: products }, onSubmit: function (values, actions) {
            submit(values, client).then(function () {
                actions.setSubmitting(false);
            });
        } }, function (_a) {
        var isSubmitting = _a.isSubmitting, products = _a.values.products;
        return (React.createElement(Container, null,
            React.createElement(Form, null,
                React.createElement("div", { className: "product" },
                    products.map(function (product, idx) {
                        return (React.createElement("div", { className: "box", key: product.bgUrl },
                            React.createElement("div", { className: "box-bg", style: { backgroundImage: "url(" + product.bgUrl + ")" } },
                                React.createElement(Product, { product: product, idx: idx, registerImage: registerImage }),
                                React.createElement("div", { className: "controller" },
                                    React.createElement("ul", null,
                                        React.createElement("li", null, idx !== 0 && (React.createElement("span", { onClick: function () { return moveToLeft(products, idx); } }, "<"))),
                                        React.createElement("li", null, products.length > 1 && (React.createElement("span", { onClick: function () { return remove(products, idx); } }, "\uC0AD\uC81C"))),
                                        React.createElement("li", null, idx !== products.length - 1 && (React.createElement("span", { onClick: function () { return moveToRight(products, idx); } }, ">"))))))));
                    }),
                    React.createElement("div", { className: "box add" },
                        React.createElement("div", { className: "add-btn", onClick: function () { return addNewProduct(products); } }, "\uCD94\uAC00\uD558\uAE30"))),
                React.createElement("div", { className: "update-btn" },
                    React.createElement("button", { type: "submit", disabled: isSubmitting }, "\uBCC0\uACBD \uBC18\uC601\uD558\uAE30")))));
    })); }));
});
var templateObject_1, templateObject_2, templateObject_3;
